import React from 'react';
import { connect } from 'react-redux';

import classes from './HotelReview.scss';

import reviewPhoto from '../../../assets/images/review-photo.jpg';

const hotelReview = (props) => {

    console.log(props);

    let tripInfo = props.tripInfo;
    let extendedTripInfo = props.extendedTripInfo;
    let personReview = props.tripInfo.review[0];
    let rating = null;

    if (tripInfo.averageRating >= 4.5) {
        rating = 'Excellent';
    } else if (tripInfo.averageRating >= 3.5) {
        rating = 'Very Good';
    } else if (tripInfo.averageRating >= 2.5 ) {
        rating = 'Good';
    } else {
        rating = 'Average';
    } 

    let numberOfReviews = parseInt(tripInfo.noOfReviews, 10);
    let ratingCountExcellent = parseInt(props.extendedTripInfo.reviewRatingCount['5'], 10);
    let ratingCountVeryGood = parseInt(props.extendedTripInfo.reviewRatingCount['4'], 10);
    let ratingCountAverage = parseInt(props.extendedTripInfo.reviewRatingCount['3'], 10);
    let ratingCountPoor = parseInt(props.extendedTripInfo.reviewRatingCount['2'], 10);
    let ratingCountTerrible = parseInt(props.extendedTripInfo.reviewRatingCount['1'], 10);
    let excellentPercentage = Math.floor((ratingCountExcellent / numberOfReviews) * 100);
    let veryGoodPercentage = Math.floor((ratingCountVeryGood / numberOfReviews) * 100);
    let averagePercentage = Math.floor((ratingCountAverage / numberOfReviews) * 100)
    let poorPercentage = Math.floor((ratingCountPoor / numberOfReviews) * 100);
    let terriblePercentage = Math.floor((ratingCountTerrible / numberOfReviews) * 100);

    return (
        <div className={`u-backgroundColorWhite`}>
            <div className={classes.RowOne}>
                <div className={`u-flex`}>
                    <div className={`mr-12 phone-mr-6 u-flex align-items-center phone-f-column`}>
                        <div className={classes.Rating}>
                            <div className={`${classes.RatingBox} u-flex justify-content-center align-items-center mb-2`}>
                                <p className={`u-fontSize20 u-fontWeightMedium u-textColorWhite`}>{tripInfo.averageRating}</p>
                            </div>
                            {/* <ul className={`u-flex justify-content-between align-items-center`}>
                                <li className={classes.RatingDots}></li>
                                <li className={classes.RatingDots}></li>
                                <li className={classes.RatingDots}></li>
                                <li className={classes.RatingDots}></li>
                                <li className={classes.RatingDots}></li>
                            </ul> */}
                            <img src={personReview.ratingImage} alt='Review' className={`u-width70`}/>
                        </div>
                        <div className={classes.Divider}></div>
                        <div> 
                            <h3 className={`u-fontSize20 u-fontWeightMedium u-textColorGreenLight`}>{rating}</h3>
                            <p className={`u-fontSize13 u-textColorNormal`}>{tripInfo.noOfReviews} Reviews</p>
                        </div>
                    </div>
                    <div>
                        <ul>
                            <li className={`u-flex justify-content-between align-items-center`}>
                                <span className={classes.RatingType}>Excellent</span>
                                <div className={`u-width120`} style={{backgroundColor: "rgba(151, 151, 151, .2)"}}>
                                    <div className={classes.RatingBar} style={{ width: excellentPercentage + '%' }}></div>
                                </div>
                                <span className={classes.RatingNumber}>{props.extendedTripInfo.reviewRatingCount['5']}</span>
                            </li>
                            <li className={`u-flex justify-content-between align-items-center`}>
                                <span className={classes.RatingType}>very good</span>
                                <div className={`u-width120`} style={{backgroundColor: "rgba(151, 151, 151, .2)"}}>
                                    <div className={classes.RatingBar} style={{ width: veryGoodPercentage + '%' }}></div>
                                </div>
                                <span className={classes.RatingNumber}>{props.extendedTripInfo.reviewRatingCount['4']}</span>
                            </li>
                            <li className={`u-flex justify-content-between align-items-center`}>
                                <span className={classes.RatingType}>Average</span>
                                <div className={`u-width120`} style={{backgroundColor: "rgba(151, 151, 151, .2)"}}>
                                    <div className={classes.RatingBar} style={{ width: averagePercentage + '%' }}></div>
                                </div>
                                <span className={classes.RatingNumber}>{props.extendedTripInfo.reviewRatingCount['3']}</span>
                            </li>
                            <li className={`u-flex justify-content-between align-items-center`}>
                                <span className={classes.RatingType}>Poor</span>
                                <div className={`u-width120`} style={{backgroundColor: "rgba(151, 151, 151, .2)"}}>
                                    <div className={classes.RatingBar} style={{ width: poorPercentage + '%' }}></div>
                                </div>
                                <span className={classes.RatingNumber}>{props.extendedTripInfo.reviewRatingCount['2']}</span>
                            </li>
                            <li className={`u-flex justify-content-between align-items-center`}>
                                <span className={classes.RatingType}>Terrible</span>
                                <div className={`u-width120`} style={{backgroundColor: "rgba(151, 151, 151, .2)"}}>
                                    <div className={classes.RatingBar} style={{ width: terriblePercentage + '%' }}></div>
                                </div>
                                <span className={classes.RatingNumber}>{props.extendedTripInfo.reviewRatingCount['1']}</span>
                            </li>
                        </ul>
                    </div>
                    <div className={`ml-8 mr-8`}></div>
                    <div>
                        <ul className={`u-width180`}>
                            {extendedTripInfo.subratings.map((item, index) => {
                                return <li key={index} className={`u-flex justify-content-between align-items-center`}>
                                    <span className={`u-width80 u-textAlignRight`}>{item.localized_name}</span>
                                    <img src={item.rating_image_url} alt='Rating URL' />
                                </li>
                            })}
                        </ul>
                    </div>
                </div>
            </div>
            <div className={classes.RowTwo}>
                <div className={`u-flex`}>
                    {
                        props.tripInfo.review.slice(0, 3).map((review, index) => {
                            return <div className={`u-flex align-items-start mb-4 f-1`} key={index}>
                                <div className={`mr-6 phone-align-self-start`}>
                                    <div className={`u-textAlignCenter`} style={{width: '8rem'}}>
                                        <div className={`mb-1`}>
                                            {/* <img src={reviewPhoto} alt='Review' className={classes.ReviewImage}/> */}
                                            <div className={`${classes.ReviewImage} u-flex align-items-center justify-content-center`}>
                                                {review.name[0].toUpperCase()}
                                            </div>
                                        </div>
                                        <p className={`u-fontSize11 u-lineHeight1 u-fontWeightMedium u-textColorNormal u-noWrapWithEllipsis`}>{review.name}</p>
                                        <span className={`u-textColorLight u-fontSize11 u-lineHeight1 u-FontItalic`}>1 week ago</span>
                                    </div>
                                </div>
                                <div className={`pr-4 phone-pr-0`}>
                                    <div className={`mb-1`}>
                                        <img src={review.ratingImage} alt='Review'/>
                                    </div>
                                    <div className={`mb-2`}>
                                        <h3 className={`u-fontSize13 u-textColorLight u-fontWeightMedium`}>{review.reviewTitle}</h3>
                                    </div>
                                    <p className={`u-textColorLight u-height60 u-overflowScrollY`}>{review.review}</p>
                                </div>
                            </div>
                        })
                    }
                </div>                            
                {/* <div>
                    <a className={`u-textAlignCenter u-textColorPrimary u-fontWeightMedium u-fontSize13 u-cursorPointer u-block`}>Read More Reviews <FontAwesomeIcon icon="angle-down" color="#666" size="1x" className={`u-textColorPrimary`} /></a>
                </div> */}
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        tripInfo: state.hotels.tripInfo,
        extendedTripInfo: state.hotels.extendedTripInfo
    }
}

export default connect(mapStateToProps)(hotelReview);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelReview/HotelReview.js